<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 9.8a8.2 8.2 0 1 0-16.4 0 8.2 8.2 0 0 0 16.4 0m1.6 0c0 5.412-4.388 9.8-9.8 9.8S0 15.212 0 9.8 4.387 0 9.8 0c5.412 0 9.8 4.387 9.8 9.8" fill="currentColor"/>
<path d="M12.71 6.858a.8.8 0 0 1 1.179 1.084l-4.601 5a.8.8 0 0 1-1.154.023l-2.4-2.4a.8.8 0 0 1 1.131-1.131l1.81 1.81z" fill="currentColor"/>
</svg>
